import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import ReactStars from 'react-rating-stars-component';
import { useFormik } from 'formik';
import { auth } from '../utils/utils';

const ReviewForm = props => {
  const { orgId } = props;
  const [commentedPosted, setCommentPosted] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState('success')
  const [starValue, setStarValue] = useState();

  const ratingChanged = newRating => {
    setStarValue(newRating);
  };

  const validate = values => {
    const errors = {};

    if (!values.review) {
      errors.review = 'Required';
    } else if (isNaN(starValue)) {
      errors.rating = 'Rating is required.'
    } else if (values.review.length < 20 || values.review.length > 200) {
      errors.review = 'Must be between 20 and 200 characters';
    }
    
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      rating: '',
      review: '',
    },
    validateOnChange: false,
    validateOnBlur: false,
    validate,
    onSubmit: async values => {
      const payload = {
        data: {
          type: "comment--comment",
          attributes: {
            entity_type: "node",
            field_name: "field_reviews",
            subject: "review",
            comment_body: {
              value: values.review,
              format: "plain_text"
            },
            field_first_name: values.name,
            field_star_rating: starValue
          },
          relationships: {
            entity_id: {
              data: {
                type: "node--organisations",
                id: orgId
              }
            }
          }
        }
      }

      const sessionToken = await fetch(`${process.env.REACT_APP_EXT_API_URL}/session/token`).then(res => res.text()).catch(() => '')

      if (sessionToken && sessionToken.length > 0) {
        fetch(`${process.env.REACT_APP_EXT_API_URL}/api/comment/reviews`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'X-CSRF-Token': sessionToken
          },
          body: JSON.stringify(payload)
        })
        .then(res => res.json())
        .then(res => {
          if (res?.data?.id) {
            setSubmissionStatus('success')
          } else {
            setSubmissionStatus('fail')
          }

          setCommentPosted(true)
        })
        .catch((error) => {
          setSubmissionStatus('fail')
          setCommentPosted(true)
        });
      }
    },
  });
  return (
    <>
    {commentedPosted ? (
      <div className="submission-status">
        {submissionStatus === 'success' ? (
          <>
            <p className="submission-status__title">Review successfully submitted</p>
            <p className="submission-status__message">
              Your review has been successfully submitted and will be reviewed shortly by our team.
            </p>
          </>
        ) : (
          <>
            <p className="submission-status__title">Review submission failed</p>
            <p className="submission-status__message">
             Please check your review details and try again later.
            </p>
          </>
        )}
      </div>
    ) : (
      <form onSubmit={formik.handleSubmit} className="p-4 review-form w-100">
        <Form.Group>
          <Form.Label htmlFor="name">Name</Form.Label>
          <Form.Control
            id="name"
            name="name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.name}
            className="form-text"
          />
        </Form.Group>
        <Form.Group>
          <Form.Label htmlFor="rating">Rating</Form.Label>{' '}
          <ReactStars
            name="rating"
            count={5}
            onChange={ratingChanged}
            size={30}
            activeColor="#3F2B56"
          />
          {formik.errors.rating ? <div>{formik.errors.rating}</div> : null}
        </Form.Group>
        <Form.Group>
          <label htmlFor="review">Review</label>
          <Form.Control
            as="textarea"
            cols={5}
            id="review"
            name="review"
            onChange={formik.handleChange}
            value={formik.values.review}
            className="form-textarea"
          />
          {formik.errors.review ? <div>{formik.errors.review}</div> : null}
        </Form.Group>
        <Button type="submit">Submit</Button>
      </form>
    )}
    </>
  );
};

export default ReviewForm;
